import { Description as HeadlessDescription } from "@headlessui/react";
import { classNames } from "../../utils/classNames";
import { Text } from "../Text";

export function DialogDescription({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"p">) {
  return (
    <HeadlessDescription
      as={Text}
      {...props}
      className={classNames("mt-2 text-pretty leading-5", className)}
    />
  );
}
